export default __webpack_public_path__ + "static/media/logo-carfax-color.820e570a.png";